import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { createFund } from 'lib/api/funds';
import CustomButton from 'lib/designSystem/Button';
import PageHeader from 'lib/designSystem/PageHeader';
import {
  buildValidation,
  formatMoney,
  formatMoneyBack,
  showAlert,
  validaRut,
} from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const initialState = {
  name: '',
  id: '',
  cost: 0,
  amount: 0,
};

const NewFund: React.FC<Props> = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const { mutate, isPending } = createFund(dispatch);
  const [fund, setFund] = useState(initialState);

  const { hasError: idHasError, message: idErrorMessage } = buildValidation(
    !fund.id.length,
    !!fund.id.length && !validaRut(fund.id),
    'Rut obligatorio',
    'Rut inválido',
  );

  const { hasError: nameHasError, message: nameErrorMessage } = buildValidation(
    !fund.name.length,
    false,
    'Nombre obligatorio',
    '',
  );

  const { hasError: costHasError, message: costErrorMessage } = buildValidation(
    !fund.cost,
    false,
    'Costo obligatorio',
    '',
  );

  const handleCreate = async () => {
    if (idHasError || nameHasError || costHasError) {
      return showAlert(
        dispatch,
        'error',
        `${idErrorMessage} ${nameErrorMessage} ${costErrorMessage}`,
      );
    }
    mutate(fund, {
      onSuccess: () => setOpen(false),
    });
  };

  return (
    <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        <PageHeader.TitleOnly
          iconType="add"
          iconVariant="primary"
          title="Nuevo fondo"
          subtitle="Ingrese los datos del nuevo fondo"
        />
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Nombre"
          fullWidth
          margin="normal"
          value={fund.name}
          onChange={(e) => setFund({ ...fund, name: e.target.value })}
        />
        <TextField
          label="Rut"
          fullWidth
          margin="normal"
          value={fund.id}
          onChange={(e) => setFund({ ...fund, id: e.target.value })}
        />
        <TextField
          label="Costo"
          fullWidth
          margin="normal"
          type="number"
          inputProps={{ min: 0, max: 100, step: 0.01 }}
          value={fund.cost || ''}
          onChange={(e) =>
            setFund({
              ...fund,
              cost: Number(e.target.value),
            })
          }
        />
        <TextField
          label="Monto"
          fullWidth
          margin="normal"
          value={formatMoney(fund.amount)}
          onChange={(e) => {
            const nonFomatted = formatMoneyBack(e.target.value);
            setFund({ ...fund, amount: nonFomatted });
          }}
        />
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={() => setOpen(false)} color="secondary">
          Salir
        </CustomButton>
        <CustomButton
          onClick={() => handleCreate()}
          color="primary"
          disabled={isPending}
          loading={isPending}
        >
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NewFund;
